export class CustomDocumentUploadFile {
  public get hasError(): boolean {
    return this.errorMessage && this.errorMessage.trim() !== '';
  }
  constructor(
    public fileName: string,
    public errorMessage: string = '',
    public rawFile: File,
    public isTempFile = true,
    public isUploading = true
  ) {}
}
